/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} External_Apis_Auth_NoneInputs */



/**
* | output |
* | --- |
* | "No authentication" |
*
* @param {External_Apis_Auth_NoneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const external_apis_auth_none = /** @type {((inputs?: External_Apis_Auth_NoneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<External_Apis_Auth_NoneInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Keine Authentifizierung")
	return /** @type {LocalizedString} */ ("No authentication")
});